import { darkTheme as theme } from './../dark'

export const MuiButton = {
  root: {
    textTransform: 'none'
  },
  outlinedPrimary: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    border: '1px solid ' + theme.palette.primary.light,
    '&:hover, :active, :focus': {
      borderColor: theme.palette.secondary.main
    }
  },
  disabled: {
    '&.MuiButton-outlinedPrimary': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.light
    }
  },
  textPrimary: {
    color: theme.palette.common.white
  }
}
